import {isEqual} from "lodash";
import * as rdiff from "recursive-diff";


export const diffDicts = (oldDict, newDict) => {
    const diff = rdiff.getDiff(oldDict, newDict, true);

    return diff
};

export const diffArrays = (oldArr, newArr, getObjId) => {
    const oldArrIndex = {};
    const changes = [];

    // Create index of old array
    for (let oldObj of oldArr) {
        const oldObjId = getObjId(oldObj);

        oldArrIndex[oldObjId] = {obj: oldObj, isFoundInNewArr: false};
    }

    // Iterate through new array and find changes compared to old array
    for (let newObj of newArr) {
        const newObjId = getObjId(newObj);

        if (newObjId in oldArrIndex) {
            if (!isEqual(newObj, oldArrIndex[newObjId].obj)) {
                changes.push({type: "update", id: newObjId, changes: diffDicts(oldArrIndex[newObjId].obj, newObj)});
            }

            oldArrIndex[newObjId].isFoundInNewArr = true;
        } else
            changes.push({type: "add", id: newObjId});
    }

    // Iterate through old index and find objects that wasn't found in new array
    for (let oldObjId of Object.keys(oldArrIndex)) {
        if (!oldArrIndex[oldObjId].isFoundInNewArr)
            changes.push({type: "remove", id: oldObjId});
    }

    return changes
};